module.exports = __webpack_public_path__ + "img/logo-footer.8cb2db6a.png";